import DashboardWidgetController from 'dashboard/components/dashboard-widget/dashboard-widget-controller';

import { checkAccess } from 'app/actions/app.actions';
import { isChainHeadSelector, isSuperChainSelector } from 'selectors';

import * as api from 'dashboard/resources/earnings.api';

import template from './net-earnings-widget.html';

const mapStateToThis = ({ session }) => {
  const { retailer } = session;
  const isSuperChain = isSuperChainSelector({ session });
  const isChainHead = isChainHeadSelector({ session });

  return {
    retailer,
    isSuperChain,
    isChainHead,
  };
};

const mapDispatchToThis = {
  checkAccess,
};

// eslint-disable-next-line no-undef
@Inject('$scope', '$ngRedux', 'gettextCatalog', '$state')
class NetEarningsWidgetController extends DashboardWidgetController {
  constructor() {
    super();
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    this.isHistoryLinkVisible = (!this.isSuperChain || this.isChainHead) && this.checkAccess('netearnings.history');
    const retailerId = this.$state.params.retailerNo || this.retailer.retailerId;

    this.loadDataAsync(() => api.fetchNetEarnings(retailerId));
  }

  $onDestroy() {
    this.unsubscribe();
  }
}

export default class NetEarningsWidgetComponent {
  constructor() {
    this.template = template;
    this.controller = NetEarningsWidgetController;
    this.bindings = {
      isEditMode: '<',
      isRemovable: '<',
      removeWidget: '&?',
    };
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/earnings/net-earnings-widget-component.js